// extracted by mini-css-extract-plugin
export default {"trailsText":"styles_trailsText__VOHJJ","container":"styles_container__Zfxdj"};